module.exports = __webpack_public_path__ + "static/media/rogersCredit2.0ada22e3.png";